var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('networks-provider',{staticStyle:{"height":"100%"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
    var campaign = ref.campaign;
    var contact = ref.contact;
    var proposal = ref.proposal;
    var networkId = ref.networkId;
    var forceReloadContact = ref.forceReloadContact;
    var handleConnectInstagram = ref.handleConnectInstagram;
    var connectionSource = ref.connectionSource;
return [_c('connect-network-view',{attrs:{"campaign":campaign,"proposal":proposal,"contact-id":contact.id,"network-id":networkId,"connection-source":connectionSource},on:{"load-contact":forceReloadContact,"connect-instagram":handleConnectInstagram}})]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }